/* global globalThis */
const session = globalThis.sessionStorage;
export default session;
